import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";
import { API_BASE_URL } from "../config"; // adjust path if needed

export default function ListingActivationSuccess() {
  const navigate = useNavigate();
  const location = useLocation();

  const [listingId, setListingId] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchListingId = async () => {
      try {
        const params = new URLSearchParams(location.search);
        const sessionId = params.get("session_id");

        if (!sessionId) {
          setLoading(false);
          return;
        }

        const res = await fetch(
          `${API_BASE_URL}/api/payment/listing-activation-status?session_id=${encodeURIComponent(sessionId)}`,
          {
            credentials: "include",
          }
        );

        const data = await res.json();

        if (res.ok && data?.listingId) {
          setListingId(data.listingId);
        }
      } catch (err) {
        console.error("❌ Failed to fetch listing activation status:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchListingId();
  }, [location.search]);

  return (
    <div
      style={{
        maxWidth: "700px",
        margin: "60px auto",
        padding: "30px",
        background: "#fff",
        borderRadius: "12px",
        boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
        textAlign: "center",
      }}
    >
      <FaCheckCircle
        style={{ fontSize: "70px", color: "#2e7d32", marginBottom: "20px" }}
      />

      <h1 style={{ color: "#2e7d32", marginBottom: "10px" }}>
        Listing Activation Successful
      </h1>

      <p style={{ fontSize: "1.1rem", color: "#555", marginBottom: "15px" }}>
        Your <strong>Lawn Mowing listing</strong> is now active and visible to buyers
        on Client Exchange.
      </p>

      <p style={{ color: "#555", maxWidth: "520px", margin: "0 auto" }}>
        You have paid a <strong>one-time listing activation fee</strong> equal to
        <strong> 25% of your listing price</strong>. This fee activates your listing
        and allows buyers to view and purchase it.
      </p>

      <div
        style={{
          marginTop: "25px",
          padding: "15px",
          background: "#f1f8f4",
          borderRadius: "8px",
          fontSize: "1.05rem",
          color: "#2e7d32",
          fontWeight: "bold",
        }}
      >
        {loading
          ? "Finalising your listing reference..."
          : listingId
          ? `Your Listing ID: ${listingId}`
          : "Your listing is now live and visible to buyers."}
      </div>

      <p style={{ marginTop: "12px", color: "#555" }}>
        A confirmation email has been sent with your full listing details.
      </p>

      <div
        style={{
          marginTop: "30px",
          padding: "20px",
          background: "#f9fdfb",
          borderRadius: "10px",
          textAlign: "left",
          maxWidth: "520px",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <h3 style={{ color: "#2e7d32", marginBottom: "10px" }}>
          What happens next?
        </h3>
        <ul style={{ color: "#555", lineHeight: "1.7", paddingLeft: "20px" }}>
          <li>Your listing is now visible to buyers</li>
          <li>Buyers can purchase your listing instantly</li>
          <li>You’ll receive an email when a buyer completes payment</li>
          <li>Client handover details will be shared after purchase</li>
        </ul>
      </div>

      <div style={{ marginTop: "40px", display: "flex", gap: "15px" }}>
        <button
          onClick={() => navigate("/my-listings")}
          style={{
            flex: 1,
            padding: "14px",
            background: "#4caf50",
            color: "#fff",
            border: "none",
            borderRadius: "8px",
            fontSize: "1rem",
            fontWeight: "bold",
            cursor: "pointer",
          }}
        >
          Go to My Listings
        </button>

        <button
          onClick={() => navigate("/dashboard")}
          style={{
            flex: 1,
            padding: "14px",
            background: "#0288d1",
            color: "#fff",
            border: "none",
            borderRadius: "8px",
            fontSize: "1rem",
            fontWeight: "bold",
            cursor: "pointer",
          }}
        >
          Go to Dashboard
        </button>
      </div>
    </div>
  );
}